


































import { Vue, Component } from "vue-property-decorator";
import starImg from "@/assets/star.png";
import starActiveImg from "@/assets/star_active.png";
import defaultImg from "@/assets/old_default.jpg";
import { getGoodsList, star } from "@/http/goods";
import { GoodsItem, GoodsList } from "@/interface/goods";
import { Getter } from "vuex-class";
import { myUpload } from "@/http/login.api";
@Component
export default class Oldgoods extends Vue {
  defaultImg = defaultImg;
  linkDetail(row: any) {
    if (row.status !== 0) return;
    this.$router.push(`/old/detail/${row.id}`);
  }
  list: Array<GoodsItem> = [];
  @Getter("isLogin") isLogin: any;
  async linkAdd() {
    await myUpload();
    this.$router.push(`/old/add`);
  }
  // 当前点赞图片
  getImageUrl(item: GoodsItem) {
    return !item.like ? starImg : starActiveImg;
  }
  // 封面图片
  getCoverImage(item: GoodsItem) {
    return window.StaticUrl + item.oldObjectImages[0].url;
  }
  async star(data: GoodsItem) {
    const { id, like } = data;
    const res = await star({
      id,
      like: +!like
    });
    data = Object.assign(data, {
      likeCnt: like ? data.likeCnt - 1 : data.likeCnt + 1,
      like: !like
    });
  }
  async getList() {
    try {
      const res = await getGoodsList({ pageNum: 1, pageSize: 1000000 });
      this.list = res.data;
    } catch (error) {
      this.list = [];
    }
  }
  mounted() {
    console.log(process.env.BASE_URL);
    this.getList();
  }
}
